export default (state = false, action = {}) => {
  switch (action.type) {
    case 'WELCOME_VISIBLE':
      return action.payload;
    default:
      return state;
  }
};
